import React from 'react';
interface IProps {
    className?: string;
    fill?: string;
}
export default ({ className, fill = 'white' }: IProps) => {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86.48 42.82"><g><path fill={fill} d="m0,42.82h86.48L43.64,0,0,42.82Zm36.88-2.07c.27-.57.52-1.05.64-1.28,1.69-3.05,4.37-5.71,6.76-7.53,5.11-3.92,13.86-3.35,15.92,3,.72-1.8.85-2.89,1.29-5.33,1.08-5.98-1.08-9.04-6.14-10.79-2.58-.89-7.94-.59-9.95.62-.42.26-.82.56-1.15.94-.35.41-.68.84-1.07,1.21-1.73-.69-2.52-1.49-5.16-2.87,3.63-1.17,8.42-.04,9.19-1.86.24-.56-.27-.86-.7-1.04-1.39-.6-2.82-1.1-4.29-1.46-1.33-.32-2.68-.52-4.05-.62-1.38-.1-2.77-.09-4.16-.04-.24,0-.82.04-1.48.07l11.08-10.87,37.86,37.84h-44.6Z"/></g></svg>
    );
}